import { render, staticRenderFns } from "./successTwo.vue?vue&type=template&id=7049e635&scoped=true&"
import script from "./successTwo.vue?vue&type=script&lang=js&"
export * from "./successTwo.vue?vue&type=script&lang=js&"
import style0 from "./successTwo.vue?vue&type=style&index=0&id=7049e635&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7049e635",
  null
  
)

export default component.exports